export default __webpack_public_path__ + "static/media/demos-image-01.e3c6c116.svg";